import { render, staticRenderFns } from "./CafeReports.vue?vue&type=template&id=1c010b2d&"
import script from "./CafeReports.vue?vue&type=script&lang=js&"
export * from "./CafeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports